<template>
    <admin-layout>

    <div class="w-full flex-col pb-12 mx-6">

     <form @submit.prevent="submit">
      <slot></slot>


      <div class="w-full flex flex-col">
        <label for="client" class="block text-white text-sm font-bold mb-2">Seleziona cliente</label>
            <div class="relative mb-6">
            <select required v-model="form.client" class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-3 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
            <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
            </select>
        </div>
      </div>
      
      <div class="w-full flex flex-col">
        
        <div class="w-full">
            <label class="text-xs text-white" for="">1</label>
            <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_1">
        </div>

        
        <div class="w-full">
          <label class="text-xs text-white" for="">2</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_2">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">3</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_3">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">4</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_4">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">5</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_5">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">6</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_6">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">7</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_7">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">8</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_8">
        </div>

        <div class="w-full mx-2">
          <label class="text-xs text-white" for="">9</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_9">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">10</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_10">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">11</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_11">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">12</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_12">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">13</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_13">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">14</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_14">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">15</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_15">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">16</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_16">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">17</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_17">
        </div>

        <div class="w-full">
          <label class="text-xs text-white" for="">18</label>
          <input class="bg-transparent border-b m-auto block border-gray-500 w-full mb-6 text-gray-600 pb-1" type="text" v-model="form.score_18">
        </div>


      </div>
        

      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline relative w-full flex-grow md:flex-1 m-1 mt-8"
      >aggiungi questionario</button>
    </form>

        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        components: {
            AdminLayout
        },
        props:['users'],
        data() {
            return {
              sending: false,
              form: {
                cliente: null,
                score_1: null,
                score_2: null,
                score_3: null,
                score_4: null,
                score_5: null,
                score_6: null,
                score_7: null,
                score_8: null,
                score_9: null,
                score_10: null,
                score_11: null,
                score_12: null,
                score_13: null,
                score_14: null,
                score_15: null,
                score_16: null,
                score_17: null,
                score_18: null
              }
            };
        },
        methods: {
        submit() {
          this.$inertia.post(this.route('manual.store'), this.form, {
            onStart: () => this.sending = true,
            onFinish: () => this.sending = false,
          })
        },
      },
    }
</script>